var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"TC-container"},[_c('div',{staticClass:"terms-and-conditions"},[_c('SimplePageBuilder',{attrs:{"response":_vm.response}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }